export default __webpack_public_path__ + "static/media/blue-camera.9d56745b.svg";